<template>
  <div :class="['search', { mini: mini }]">
    <div class="content">
      <div class="left-input">
        <el-autocomplete
          v-model="searchValue"
          class="input"
          :fetch-suggestions="getHistory"
          :placeholder="$t('components.search.placeholder')"
          @select="({ value }) => selectItem(value)"
          @keydown.enter.native="search()"
        />
      </div>
      <div class="right-button" @click="search()">
        <i class="el-icon-search" />
      </div>
    </div>
    <div v-if="hotwords.length > 0 && displayHotword" class="hotwords">
      <span>{{ $t('components.search.hotword') }}</span>
      <span
        v-for="item in hotwords"
        :key="item"
        class="hotword"
        @click="selectItem(item)"
        >{{ item }}</span
      >
    </div>
  </div>
</template>
<script>
import { getSearchHotWord } from '@/api/home'
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    mini: {
      type: Boolean,
      default: false
    },
    displayHotword: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      searchValue: '',
      history: [],
      hotwords: []
    }
  },
  async mounted() {
    this.searchValue = this.value
    const history = localStorage.getItem('searchHistory') || ''
    this.history =
      history.split(',').map((item) => ({
        value: item
      })) || []
    const { data: hotwords } = await getSearchHotWord({
      source: '2'
    })
    this.hotwords = hotwords
  },
  methods: {
    search() {
      if (!this.searchValue && this.$route.name !== 'search') {
        return false
      }
      if (this.history.every((item) => item.value !== this.searchValue)) {
        this.history.unshift({
          value: this.searchValue
        })
        if (this.history.length > 5) {
          this.history = this.history.slice(0, 5)
        }
        localStorage.setItem(
          'searchHistory',
          this.history.map((item) => item.value)
        )
      }
      this.$emit('search', this.searchValue)
    },
    getHistory(_queryString, cb) {
      cb(this.history)
    },
    selectItem(item) {
      this.searchValue = item
      this.search()
    }
  }
}
</script>
<style lang="scss">
@import '../../styles/variables.scss';
.search {
  position: relative;
  
  .content {
    display: flex;
    padding: 0;
  }

  .left-input {
    border-radius: 30px 0 0 30px;
    padding: 10px 10px 10px 30px;
    background: $white;
    height: 60px;
    // ie上显示：
    flex: 1;
    flex: calc(100% - 90px);
    z-index: 1;
    .input {
      width: 100%;
      .el-input__inner {
        font-size: 16px;
        border: none;
      }
    }
  }
  .right-button {
    border-radius: 0 30px 30px 0;
    width: 90px;
    height: 60px;
    line-height: 60px;
    background-color: var(--primary);
    color: $white;
    font-size: 24px;
    text-align: center;
    cursor: pointer;
    font-weight: bold;
    z-index: 1;

    &:hover,
    &:active {
      background-color: var(--darken-primary);
    }
  }
  .hotwords {
    text-align: left;
    margin-top: 8px;
    padding: 0 30px;
    .hotword {
      cursor: pointer;
      margin-right: 6px;
      &:hover {
        color: var(--primary);
      }
    }
  }

  &.mini {
    width: 400px;
    height: 40px;

    .left-input {
      border-radius: 20px 0 0 20px;
      padding: 0 10px 0 20px;
      height: 40px;
      flex: calc(100% - 60px);
      .input .el-input__inner {
        font-size: 16px;
        height: 40px;
        line-height: 40px;
        border: none;
      }
    }
    .right-button {
      border-radius: 0 20px 20px 0;
      width: 60px;
      height: 40px;
      line-height: 40px;
    }
    .hotwords {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Search/index.vue